// Shell-wide UI state (palette, shortcut help, page title, "new entry" editor).

class ShellState {
  paletteOpen = $state(false);
  shortcutsOpen = $state(false);
  mobileMoreOpen = $state(false);
  /** Page title shown in the document title and the mobile top bar. */
  title = $state('');
  /**
   * Request to open the entry editor from anywhere (shortcut "n", palette).
   * The registrations page module listens to this.
   */
  newEntryRequest = $state(0);
}

export const shell = new ShellState();
